<template>
    <div class="forgetPS">
        <h2 class="forgetPSText">设置新密码</h2>
        <div class="form">
            <div class="formItem">
                <p class="tag">新密码</p>
                <input class="input" type="password" v-model="password" placeholder="6-12位数字字母组合"/>
            </div>
            <div class="formItem">
                <p class="tag">再次输入</p>
                <input class="input" type="password" v-model="reconfirm" placeholder="请再输入一次"/>
            </div>
        </div>
        <div class="btn" @click="onSave">
            <span>确认</span>
        </div>
    </div>
</template>

<script>
    /*
    * 设置新密码
    * */
    import {restPassword} from '../../../api/login'

    export default {
        name: "SetNewPS",
        data() {
            return {
                reconfirm: '',
                password: '',
                ticket: '',
            }
        },
        created() {
            this.ticket = this.$route.query.ticket;
        },
        methods: {
            onSave() {
                if (!this.password) return this.toast({text: '请输入新密码', icon: 'warning'});
                if (!this.reconfirm) return this.toast({text: '请再次输入密码', icon: 'warning'});
                if (this.password.length < 6 || this.reconfirm.length < 6) return this.toast({text: '请输入至少6位的密码', icon: 'warning'});
                if (this.reconfirm !== this.password) return this.toast({text: '两次密码不一致', icon: 'warning'});
                restPassword(this.password, this.reconfirm, this.ticket).then(_ => {
                    this.alert({
                        text: '新密码设置成功',
                        confirmButtonText: '去登录',
                        fn: _ => {
                            this.$store.commit('SET_TOKEN', null);
                            this.toPage('/login', true);
                        }
                    })
                })
            },
        }
    }
</script>

<style scoped>
    .forgetPS {
        padding: 0 7vw;
        min-height: 100vh;
        background-color: white;
    }

    .forgetPSText {
        font-size: 5vw;
        color: #1b1b4e;
        line-height: 20vw;
    }

    .tag {
        margin-bottom: 2vw;
        font-size: 3vw;
        color: #3b4664;
    }

    .formItem {
        position: relative;
        margin-bottom: 5vw;
        border-bottom: 1px solid #ededed;
    }

    .input {
        display: block;
        width: 100%;
        border: none;
        height: 10vw;
        padding: 2vw 0;
        line-height: 10vw;
        font-size: 4vw;
        box-sizing: border-box;
        outline: none;
    }

    .input::placeholder {
        color: #AEB3C0;
    }

    .getCodeBtn {
        position: absolute;
        top: 53%;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 18vw;
        height: 5vw;
        border: solid 1px #49a7f4;
        font-size: 3vw;
        color: #49a7f4;
    }

    .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 85vw;
        height: 11vw;
        margin-top: 13vw;
        font-size: 5vw;
        color: #ffffff;
        background-image: linear-gradient(90deg,
        #31a2fe 0%,
        #4ca8f3 100%),
        linear-gradient(
            #ff6a49,
            #ff6a49);
        background-blend-mode: normal,
        normal;
        box-shadow: 0vw 1vw 3vw 0vw
        rgba(49, 162, 254, 0.39);
        border-radius: 5vw;
    }
</style>



// WEBPACK FOOTER //
// src/page/login/setNewPS/SetNewPS.vue